const PLUGIN_CONFIG_FILE_NAME = "./_plugin-config.js";

function registerPlugins(app, pluginsContext, context) {
  const pluginContextFileNames = pluginsContext.keys();
  let pluginConfig = null;

  if(!pluginContextFileNames.includes(PLUGIN_CONFIG_FILE_NAME)) return;

  pluginConfig = pluginsContext(PLUGIN_CONFIG_FILE_NAME);
  pluginConfig = pluginConfig.default || pluginConfig;

  pluginConfig.forEach((pluginFile) => {
    let plugin = pluginsContext(pluginFile);
    plugin = plugin.default || plugin;

    app.use(plugin, context);
  });
}

export default function registerAllPlugins(app, context) {
  registerPlugins(app, require.context("~/plugins", true, /.*\.js$/), context);
  registerPlugins(app, context.allRequireContext.pluginsContext, context);
}